/**
 * @author Fernando Ruano
 * @file index.js
 * @description BloodPressure Services
 */

// Core
import endpoints from '@nephro/config/endpoints';
import { externalConnector } from '@nephro/core/connector';

// Endpoints
const { bloodPressure: bloodPressureEndpoints } = endpoints;

export class BloodPressureService {
  constructor(http) {
    this.http = http;
  }

  /**
   * Create BloodPressure
   * @param { Object } data - BloodPressure data.
   * @return { promise } - The bloodPressure promise object.
   */
  createBloodPressure = async (data) => {
    const body = { ...data };
    const url = bloodPressureEndpoints.base;
    return this.http.post(url, body);
  };

  /**
   * Get BloodPressure list with pagination
   * @param { string } paged - Activate pagination.
   * @param { string } limit - Items per page.
   * @param { string } page - Current page.
   * @return { Object } - Get bloodPressure list.
   */
  getBloodPressures = async (paged, limit, page) => {
    const queryParam = `?limit=${limit}&page=${page}&paged=${paged}`;
    let url = bloodPressureEndpoints.base;
    if (paged) {
      url = `${url}${queryParam}`;
    }
    return this.http.get(url);
  };

  /**
   * Get BloodPressure info by id
   * @param { string } id - BloodPressure id.
   * @return { Object } - Get bloodPressure list.
   */
  getBloodPressureById = async (id) => {
    const url = `${bloodPressureEndpoints.base}/${id}`;
    return this.http.get(url);
  };

  /**
   * Get BloodPressure info by patient id
   * @param { string } id - Patient id.
   * @return { Object } - Get bloodPressure list.
   */
  getBloodPressureByPatientId = async (id) => {
    const url = `${bloodPressureEndpoints.base}/findBloodPressureByPatientId/${id}`;
    return this.http.get(url);
  };

  /**
   * Delete BloodPressure by id
   * @param { string } id - BloodPressure id.
   * @return { Object } - Get bloodPressure list.
   */
  deleteBloodPressureById = async (id) => {
    const url = `${bloodPressureEndpoints.base}/${id}`;
    return this.http.delete(url);
  };

  /**
   * Update BloodPressure
   * @param { Object } data - BloodPressure data.
   * @param { object } id - BloodPressure id.
   * @return { promise } - The BloodPressure promise object.
   */
  updateBloodPressure = async (data, id) => {
    const body = { ...data };
    const url = `${bloodPressureEndpoints.base}/${id}`;
    return this.http.update(url, body, {}, 'put');
  };
}

export default new BloodPressureService(externalConnector);
